<template>
    <div>
        <b-card border-variant="dark" class="mt-4">
            <div class="height-queue">
                <div id="table-header" class="row">
                    <h4 class="col-4"><i class="fas fa-users"></i> USUÁRIOS</h4>
                    <input type="text" class="form-control col-4" v-model="searchInput" placeholder="Pesquisar">
                    <multiselect v-model="selectedQueues" :options="queues" :multiple="true" :close-on-select="false"
                        :clear-on-select="false" :hide-selected="false" :preserve-search="false"
                        :preselect-first="false" :searchable="false" label="name" track-by="name"
                        placeholder="Selecionar Filas" :select-label="'Clique para selecionar'"
                        :deselect-label="'Clique para remover'" :selected-label="'Selecionado'" :show-no-results="true"
                        class="col-3 queue-multiselect">
                        <span slot="noResult">
                            Nenhuma fila encontrada!
                        </span>
                    </multiselect>

                </div>
                <b-button :variant="pausedOperators.length > 0 ? 'danger' : 'warning'" @click="togglePauseAll" size="sm"
                    style="border-radius: 5px !important;">
                    {{ pausedOperators.length > 0 ? 'Despausar SAC' : 'Pausar SAC' }}
                </b-button>

                <b-modal id="pause-modal-realtime" size="md" title="Selecionar Pausa" hide-footer centered>
                    <div class="pause-buttons d-flex flex-column">
                        <button v-for="pause in getPauses" :key="pause.id" @click="selectPause(pause.id, pause.name)"
                            class="btn pause-button mb-2">
                            {{ pause.name }}
                        </button>
                    </div>
                </b-modal>

                <b-table id="tbDetails" small striped bordered fixed head-variant="dark" :hover="true"
                    :per-page="perPage" :fields="fields" :items="handleItems" responsive="sm" class="mt-2"
                    :current-page="currentPage" show-empty>

                    <template #empty="scope">
                        <h6 class="text-center">NENHUM USUÁRIO DISPONÍVEL</h6>
                    </template>

                    <template #cell(actions)="data">
                        <ToolTip :conSocket="conSocket" :extension="data.item.extension" :channel="data.item.channel">
                        </ToolTip>
                    </template>

                    <template #cell(available)="data">
                        <i v-if="data.value == 'Online'"
                            class="fas fa-circle text-success fa-beat-fade icon-extension-status"
                            style="--fa-animation-duration: 1.5s;"></i>

                        <i v-else class="fas fa-circle text-danger icon-extension-status"></i>
                        {{ data.value }}
                    </template>

                    <template #cell(status)="data">
                        <i v-if="data.value == 'Pausa' && data.item.number === 'almoço' && data.item.time.toSeconds() > 5700"
                            class="fas fa-circle text-danger fa-beat-fade icon-extension-status"
                            style="--fa-animation-duration: 1.5s;"></i>
                        <i v-if="data.value == 'Pausa' && data.item.number === 'café' && data.item.time.toSeconds() > 900"
                            class="fas fa-circle text-danger fa-beat-fade icon-extension-status"
                            style="--fa-animation-duration: 1.5s;"></i>
                        <i v-if="data.value == 'Pausa' && data.item.number === 'Intervalo' && data.item.time.toSeconds() > 600"
                            class="fas fa-circle text-danger fa-beat-fade icon-extension-status"
                            style="--fa-animation-duration: 1.5s;"></i>
                        {{ data.value }}
                    </template>


                    <template #cell(serviceQueue)="data">
                        <button v-if="Array.isArray(data.value)" type="button" class="btn btn-outline-dark btn-sm"
                            @click="openModal(data.item)" style="border-radius: 5px !important;">
                            {{ data.value.length }} Filas
                        </button>
                        <span v-else>{{ data.value }}</span>
                    </template>
                </b-table>

                <strong>
                    <span>Total de {{ handleItems.length }} usuários</span>
                </strong>

                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="tbDetails"
                    size="sm" align="right">
                </b-pagination>
            </div>
        </b-card>

        <dtModalManageQueues ref="dtModalManageQueues" @emitModalQueueRemove="emitQueueRemove"
            @emitModalQueueAdd="emitQueueAdd" @emitModalQueueUnPause="emitQueueUnPause"
            @emitModalQueuePause="emitQueuePause" />
    </div>
</template>

<script>
import ToolTip from './ToolTip'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Swal from 'sweetalert2';
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "RealtimeUsersDetailsTable",
    props: ["conSocket"],
    components: { ToolTip, Multiselect },
    data() {
        return {
            fields: [
                { key: 'name', label: 'NOME', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'extension', label: 'RAMAL', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'available', label: 'DISPONÍVEL', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'status', label: 'STATUS', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'number', label: 'NÚMERO / TIPO', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'serviceQueue', label: 'FILAS', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'time', label: 'TEMPO DE STATUS', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'actions', label: 'AÇÕES', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },  // Nova coluna AÇÕES
            ],
            currentPage: 1,
            perPage: 10,
            searchInput: '',
            items: [{ showActions: false, }],
            intervalTimer: null,
            attFilter: '*',
            usuariosParaPausar: [],
            pausedOperators: [],
            selectedOperators: [],
            pauseStateSac: {
                pauseReason: null,
                pauseApiSent: false,
                unpauseApiSent: false
            },
            queues: [],
            selectedQueues: [],

        }
    },
    methods: {
        ...mapActions(['fetchPausesSupervisor', 'sendOperatorPauseApi', 'sendOperatorUnpause']),

        togglePauseAll() {
            if (this.pausedOperators.length > 0) {
                // Se houver operadores pausados, despausa todos
                this.selectedOperators = this.pausedOperators;
                this.selectedOperators.forEach(operator => {
                    this.$refs.dtModalManageQueues.$emit("emitModalQueueUnPause", {
                        id: operator.id,
                        queue: "sac",
                        extension: operator.extension,
                    });

                    // Envia despausa via API
                    const unpausePayload = {
                        pauseId: this.pauseStateSac.pauseReason,
                        tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
                        queue: "sac",
                        userId: operator.id,
                    };
                    this.sendOperatorUnpause(unpausePayload);
                    localStorage.removeItem(`pauseStateSac_${operator.id}`);
                });

                this.pausedOperators = []; // Limpar operadores pausados
                this.pauseStateSac.unpauseApiSent = true;
            } else {
                // Se não houver operadores pausados, pausa todos
                this.pausarTodos();
            }
            this.$bvModal.hide("pause-modal-realtime");
        },

        pausarTodos() {
            const usuariosLogadosNaFila = this.items.filter(item => {
                return item.queues.some(queue =>
                    queue.name === "sac" && queue.status.toLowerCase() === "logado"
                );
            });

            if (usuariosLogadosNaFila.length === 0) {
                Swal.fire({
                    title: 'Atenção',
                    text: 'Nenhum operador logado na fila sac',
                    type: 'warning',
                    confirmButtonText: 'Ok'
                });
                return;
            }

            this.selectedOperators = usuariosLogadosNaFila;
            this.pauseStateSac = {
                pauseReason: null,
                pauseApiSent: false,
                unpauseApiSent: false
            };

            this.fetchPausesSupervisor(); // Importante para popular o modal com as pausas
            this.$bvModal.show("pause-modal-realtime");

            // Atualizar estado de operadores pausados
            this.pausedOperators = this.selectedOperators.filter(operator => {
                return operator.queues.some(queue => queue.name === "sac" && queue.status.toLowerCase() === "pausa");
            });
        },

        selectPause(pauseId, pauseName) {
            this.pauseStateSac.pauseReason = pauseName;

            this.selectedOperators.forEach(operator => {
                const payload = {
                    pauseId: pauseName,
                    tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
                    queue: "sac",
                    userId: operator.id,
                };

                // Verifica se o operador está logado na fila
                const fila = operator.queues.find(q => q.name === "sac");

                if (fila) {
                    if (fila.status === "Logado") {
                        // Emitir pausa
                        this.$refs.dtModalManageQueues.$emit("emitModalQueuePause", {
                            extension: operator.extension,
                            queue: "sac",
                            reason: pauseName
                        });

                        // Adicionar operador à lista de pausados
                        this.pausedOperators.push(operator);
                    } else if (fila.status === "Pausa") {
                        // Emitir despausa
                        this.$refs.dtModalManageQueues.$emit("emitModalQueueUnPause", {
                            id: operator.id,
                            queue: "sac",
                            extension: operator.extension,
                        });

                        if (!this.pauseStateSac.unpauseApiSent) {
                            const unpausePayload = {
                                pauseId: this.pauseStateSac.pauseReason,
                                tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
                                queue: "sac",
                                userId: operator.id,
                            };
                            this.sendOperatorUnpause(unpausePayload);
                            this.pauseStateSac.unpauseApiSent = true;
                        }
                    }
                }

                // Envia pausa via API
                this.sendOperatorPauseApi(payload);
            });

            this.pauseStateSac.pauseApiSent = true;
            this.updatepauseStateSac();
            this.$bvModal.hide("pause-modal-realtime");
        },


        updatepauseStateSac() {
            this.selectedOperators.forEach(operator => {
                localStorage.setItem(`pauseStateSac_${operator.id}`, JSON.stringify(this.pauseStateSac));
            });
        },

        pauseOperators() {
            this.pausedOperators = []; // limpa antes de repopular

            this.items.forEach(operator => {
                const savedState = localStorage.getItem(`pauseStateSac_${operator.id}`);
                if (savedState) {
                    this.pausedOperators.push(operator);
                }
            });
        },

        calcTimer() {
            if (this.intervalTimer) {
                clearInterval(this.intervalTimer);
            }

            this.intervalTimer = setInterval(() => {
                this.items = this.items.map((el) => {
                    if (!el.status) console.log(el);
                    if (el.status.includes("Deslogado")) return el;
                    let tempo = el.time.toSeconds();
                    tempo++;
                    el.time = tempo.toString().toHHMMSS();
                    return el;
                });
            }, 1000);
        },
        async getUsers() {
            await axios.get('/realtime/listUsersPhone')
                .then(({ data }) => {
                    if (!data) return;
                    this.items = data.map(user => {
                        const splitName = user.nome.split(" ");
                        const showName = splitName.length > 1 ? `${splitName[0]} ${splitName.at(-1)}` : splitName[0];
                        const foundItem = this.items.find(item => item.extension == user.extension_line);
                        if (foundItem) {
                            foundItem.id = user.id;
                            foundItem.name = showName;
                            foundItem.queues = user.queues.map(queue => {
                                const foundQueue = foundItem.queues.find(q => q.name == queue.name);
                                if (foundQueue) {
                                    return foundQueue;
                                } else {
                                    return {
                                        name: queue.name,
                                        alias: queue.alias,
                                        status: "Deslogado"
                                    }
                                }
                            });

                            if ((foundItem.status != "Ligação") && (foundItem.status != "Tocando")) {
                                foundItem.serviceQueue = foundItem.queues;
                            }

                            return foundItem;
                        }

                        const myQueues = user.queues.map(queue => {
                            queue.status = "Deslogado";
                            return queue;
                        });

                        return {
                            id: user.id,
                            name: showName,
                            extension: user.extension_line,
                            status: "Deslogado",
                            available: "Offline",
                            number: "",
                            queues: myQueues,
                            serviceQueue: myQueues,
                            time: "00:00:00",
                            channel: "",
                        }
                    }).sort((a, b) => {
                        const statusA = a.status.toLowerCase();
                        const statusB = b.status.toLowerCase();
                        if (statusA == statusB) return 0;
                        const nivel = {
                            "tocando": 5,
                            "ligação": 4,
                            "pausa": 3,
                            "logado": 2,
                            "deslogado": 1,
                        }

                        if (nivel[statusA] > nivel[statusB]) return -1;
                        if (nivel[statusA] < nivel[statusB]) return 1;
                        return 0;
                    });
                })
        },
        async getQueues() {
            await axios.get('user/listQueueUser')
                .then(({ data }) => {
                    if (data) this.queues = data;
                });
        },
        getTime(time) {
            if (time == NaN) return;
            let horas = ("00" + parseInt(time / 3600)).slice(-2);
            time = time - (horas * 3600);
            let minutos = ("00" + parseInt(time / 60)).slice(-2);
            time = time - (minutos * 60);
            let segundos = ("00" + parseInt(time)).slice(-2);
            const format = `${horas}:${minutos}:${segundos}`;
            if (parseInt(horas) < 1 && parseInt(minutos) < 30) {
                return { val: format, variant: 'success' };
            } else if (parseInt(horas) < 3) {
                return { val: format, variant: 'warning' };
            } else if (parseInt(horas) > 2) {
                return { val: format, variant: 'danger' };
            }
        },
        openModal(item) {
            this.$refs.dtModalManageQueues.openModal({
                id: item.id,
                extension: item.extension,
                queues: item.queues
            });
        },
        handleEventData(data, indexItem = null) {
            const availableExten = data.available.status ? "Online" : "Offline";
            const minhasFilas = data.queues.map(el => {
                let meuStatus = "Deslogado";
                if (el.loginStatus == "true") {
                    meuStatus = "Logado";
                }

                if (el.pauseStatus == "true") {
                    meuStatus = "Pausa";
                }

                return {
                    name: el.name,
                    status: meuStatus
                }
            });

            const resultItem = {
                id: 0,
                name: "",
                extension: data.extension,
                status: "Deslogado",
                available: availableExten,
                number: "",
                queues: minhasFilas,
                serviceQueue: minhasFilas,
                time: "00:00:00",
                _cellVariants: {},
                channel: "",
            };

            if (data.called.status) {
                resultItem.status = data.called.ringing ? "Tocando" : "Ligação";
                resultItem.number = data.called.number;
                resultItem.serviceQueue = data.called.queue;
                resultItem.time = data.called.date.toString().toHHMMSS();
                resultItem.channel = data.called.channel;
                resultItem._cellVariants = { status: data.called.ringing ? "danger" : "success" };
            } else if (data.paused.status) {
                const pausedQueue = data.queues.find(queue => queue.pauseStatus === "true");
                resultItem.status = "Pausa";
                resultItem.number = pausedQueue ? pausedQueue.pausedReason : "";
                resultItem.time = data.paused.date.toString().toHHMMSS();
                resultItem._cellVariants = { status: "warning" };
            } else if (data.logged.status) {
                resultItem.status = "Logado";
                resultItem.time = data.logged.date.toString().toHHMMSS();
                resultItem._cellVariants = { status: "primary" };
            }

            if (indexItem != null && indexItem >= 0) {
                resultItem.id = this.items[indexItem].id;
                resultItem.name = this.items[indexItem].name;
                resultItem.queues = this.items[indexItem].queues.map(el => {
                    const filaAtual = resultItem.queues.find(q => q.name == el.name);
                    if (filaAtual) return filaAtual;
                    return el;
                });
            }

            if (!data.called.status) resultItem.serviceQueue = resultItem.queues;

            return resultItem;
        },
        modifyItem(newItem, origin) {
            const foundExten = this.items.findIndex(el => el.extension == newItem.extension);
            if (foundExten >= 0) {
                this.items[foundExten] = this.handleEventData(newItem, foundExten);
            }
            // else {
            //     this.items.push(this.handleEventData(newItem));
            // }

            this.sortItems();
        },

        sortItems() {
            this.items.sort((a, b) => {
                const statusA = a.status ? a.status.toLowerCase() : '';
                const statusB = b.status ? b.status.toLowerCase() : '';
                const availableA = a.available ? a.available.toLowerCase() : '';
                const availableB = b.available ? b.available.toLowerCase() : '';

                const nivel = {
                    "tocando": 5,
                    "ligação": 4,
                    "pausa": 3,
                    "logado": 2,
                    "deslogado": 1,
                };

                // Caso específico para itens com status "Logado"
                if (statusA === 'logado' && statusB === 'logado') {
                    if (availableA === 'online' && availableB !== 'online') {
                        return -1; // Coloca Online acima de Offline
                    } else if (availableA !== 'online' && availableB === 'online') {
                        return 1; // Coloca Offline abaixo de Online
                    }
                }

                // Caso específico para itens com status "Deslogado"
                if (statusA === 'deslogado' && statusB === 'deslogado') {
                    if (availableA === 'online' && availableB !== 'online') {
                        return -1; // Coloca Online acima de Offline
                    } else if (availableA !== 'online' && availableB === 'online') {
                        return 1; // Coloca Offline abaixo de Online
                    }
                }

                return (nivel[statusB] || 0) - (nivel[statusA] || 0);
            });
        },

        listenQueueMember() {
            this.conSocket.on("QueueMemberUserTable", (data) => {
                this.modifyItem(data, 'qm');
            });
        },
        listenCoreShowChannel() {
            this.conSocket.on("CoreShowChannelUserTable", (data) => {
                this.modifyItem(data, 'csc');
            });
        },
        listenNewConnectedLine() {
            this.conSocket.on("NewConnectedLineUserTable", (data) => {
                this.modifyItem(data, 'ncl');
            });
        },
        listenQueueAdd() {
            this.conSocket.on("QueueMemberAddedUserTable", (data) => {
                this.modifyItem(data, 'qa');
            });
        },
        listenQueueRemoved() {
            this.conSocket.on("QueueMemberRemovedUserTable", (data) => {
                this.modifyItem(data, 'qr');
            });
        },
        listenQueueMemberPause() {
            this.conSocket.on("QueueMemberPauseUserTable", (data) => {
                this.modifyItem(data, 'qp');
            });
        },
        listenPeerStatus() {
            this.conSocket.on("PeerStatusUserTable", (data) => {
                this.modifyItem(data, 'ps');
            });
        },
        listenHangup() {
            this.conSocket.on("HangupUserTable", (data) => {
                this.modifyItem(data, 'hu');
            });
        },
        emitQueueRemove(item) {
            this.conSocket.emit("QueueRemove", {
                queues: [[item.queue]],
                extension: item.extension
            });
        },
        emitQueueAdd(item) {
            const logs = this.items.findIndex(el => el.extension == item.extension);
            if (logs >= 0) {
                const filas = this.items[logs].queues.find(q => q.status == "Deslogado");
                if (!filas) {
                    this.conSocket.emit("QueueAdd", {
                        queues: [[item.queue]],
                        extension: item.extension,
                        restart: true
                    });

                    return;
                }
            }

            this.conSocket.emit("QueueAdd", {
                queues: [[item.queue]],
                extension: item.extension
            });
        },
        emitQueueUnPause(item) {
            this.conSocket.emit("QueueUnPause", item);
        },
        emitQueuePause(item) {
            this.conSocket.emit("QueuePause", item);
        },
        getQueueAlias(queuename = '---') {
            if (this.queues.length) {
                const find = this.queues.find(el => el.name === queuename)
                if (find?.alias) return find.alias;
            }
            return queuename
        }
    },
    computed: {
        ...mapGetters(['getPauses']),
        rows() {
            return this.items.length;
        },
        handleItems() {
            let keyword = this.searchInput?.toLowerCase();
            let resultFilter = this.items;

            // Filtra pelo nome da fila selecionada
            if (this.selectedQueues.length > 0) {
                resultFilter = resultFilter.filter(item =>
                    item.queues.some(queue =>
                        this.selectedQueues.some(selectedQueue => selectedQueue.name === queue.name)
                    )
                );
            }

            if (!keyword) return resultFilter;

            return resultFilter.sort((a, b) => {
                const statusA = a.status.toLowerCase();
                const statusB = b.status.toLowerCase();
                if (statusA === statusB) return 0;

                const nivel = {
                    "tocando": 5,
                    "ligação": 4,
                    "pausa": 3,
                    "logado": 2,
                    "deslogado": 1,
                };

                return nivel[statusA] > nivel[statusB] ? -1 : 1;
            }).filter(el => {
                const extension = el.extension ? `${el.extension}`.toLowerCase() : '';
                const number = el.number ? `${el.number}`.toLowerCase() : '';
                const queue = Array.isArray(el.queues) ? el.queues.map(q => q.name).join(",").toLowerCase() : '';
                const name = el.name ? el.name.toLowerCase() : '';
                const available = el.available ? el.available.toLowerCase() : '';
                const status = el.status ? el.status.toLowerCase() : '';

                return (queue.includes(keyword) ||
                    extension.includes(keyword) ||
                    available.includes(keyword) ||
                    name.includes(keyword) ||
                    status.includes(keyword) ||
                    number.includes(keyword)
                );
            });
        },
    },
    created() {
    },
    async mounted() {
        await this.getUsers();
        await this.getQueues();
        this.conSocket.emit('QueueStatus');
        this.listenQueueMember();
        this.listenCoreShowChannel();
        this.listenNewConnectedLine();
        this.listenQueueAdd();
        this.listenQueueRemoved();
        this.listenQueueMemberPause();
        this.listenPeerStatus();
        this.listenHangup();
    },
    watch: {
        items(value, oldVal) {
            this.pauseOperators();
            
            if (!Number.isInteger(this.intervalTimer) && value.length > 0) {
                this.calcTimer();
                return
            }

            if (value.length <= 0) {
                clearInterval(this.intervalTimer);
                this.intervalTimer = null;
            }
        },
        // items: {
        //     handler(newVal, oldVal){
        //         if (!Number.isInteger(this.intervalTimer) && newVal.length > 0) {
        //             console.log('new items >> ', newVal)
        //             console.log('old items >> ', oldVal)
        //             this.calcTimer();
        //             return
        //         }

        //         if (newVal.length <= 0) {
        //             clearInterval(this.intervalTimer);
        //             this.intervalTimer = null;
        //         }
        //     },
        //     deep: true,
        //     immediate: true
        // }
    }
}
</script>

<style lang="scss" scoped>
.pause-buttons {
    padding: 0 20px;
}

.pause-button {
    border-radius: 8px;
    background-color: #f8f9fa;
    color: #495057;
    border: none;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    /* Adiciona a box-shadow */
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
    width: 100%;
    padding: 15px;
    text-align: center;
    margin-bottom: 10px;
}

.pause-button:hover {
    background-color: #e2e6ea;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.16), 0 6px 12px rgba(0, 0, 0, 0.23);
}

.blink-red {
    width: 100%;
    animation: blink-red 1s infinite;
}

@keyframes blink-red {
    0% {
        background-color: red;
    }

    50% {
        background-color: transparent;
    }

    100% {
        background-color: red;
    }
}

#table-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: black;
}

.card {
    color: black !important;
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    border-radius: 0.25rem !important;
}

.font-15 {
    font-size: 15px;
}

#action-button-view {
    cursor: pointer;
    font-size: 16px;
    color: #1c869a;
    transition: 0.25s;
    margin: 5px;
}

#action-button-view:hover {
    color: #177081;
}

#action-button-delete {
    cursor: pointer;
    font-size: 16px;
    color: #e3342f;
    transition: 0.25s;
    margin: 5px;
}

#action-button-delete:hover {
    color: #b42a26;
}

.actions-cell {
    width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
}

.action-btn {
    width: 30px;
    padding: 0.2rem;
    font-size: 0.75rem;
    margin: 0 2px;
}

.d-flex.justify-content-between {
    display: flex;
    align-items: center;
    justify-content: center;
}

.queue-multiselect {
    font-size: 14px;

    ::v-deep .multiselect__tags {
        padding: 5px 40px 0 8px;
        max-height: 37px;
        min-height: unset;
        border-radius: unset;
        border: 1px solid lightgray;
        width: 105%;
    }

    ::v-deep .multiselect__single {
        font-size: smaller;
    }
}
</style>